const SDK_VERSION = '8.15.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
